import { useState } from 'react';
import Select from 'react-select';

const regions = [
  'Scotland',
  'North East + Yorkshire',
];

const RegionSelect = ({ onChange }: { onChange: (e: any) => void }) => {
  const [selectedRegion, setSelectedRegion] = useState<string | null>(null);

  const handleChange = (e: any) => {
    if (e == null) {
      setSelectedRegion(null);
      onChange({ value: null });
      return;
    }
    setSelectedRegion(e.value);
    onChange({ value: e.value });
  };

  return (
    <Select
      placeholder="Select Region"
      isClearable
      onChange={handleChange}
      options={regions.map((r) => ({ value: r, label: r }))}
      value={selectedRegion ? { value: selectedRegion, label: selectedRegion } : null}
    />
  );
};

export default RegionSelect;